import { Table as NextUITable, TableProps } from '@nextui-org/react';

export function Table(props: TableProps) {
  return (
    <NextUITable
      {...props}
      classNames={{
        base: ['border-1', 'rounded-xl'],
        th: ['bg-secondary', 'text-black'],
        tr: [
          // "rounded-md",
          // "overflow-hidden",
          // "even:bg-[#F1F7F7]",
        ],
        td: [],
        emptyWrapper: ['whitespace-pre-line', 'py-8'],
        ...props.classNames,
      }}
      shadow="none"
      isStriped
    />
  );
}

export { TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
